import React from "react";
import PropTypes from "prop-types";
import { themr } from "react-css-themr";
import classnames from "classnames";

import styles from "./Terminal.m.scss";

function TerminalHeader(props) {
  const { theme } = props;

  return (
    <div className={classnames(theme.header)}>
      <div>{"Id"}</div>
      <div>{"Id точки обслуживания"}</div>
      <div>{"Наименование точки обслуживания"}</div>
      <div>{"Сеанс связи"}</div>
      <div>{"Успешный сеанс связи"}</div>
      <div>{"MCC"}</div>
      <div>{"Чип"}</div>
    </div>
  );
}

TerminalHeader.displayName = "TerminalHeader";

TerminalHeader.propTypes = {
  theme: PropTypes.object,
};

TerminalHeader.defaultProps = {};

export default themr("@lifepay/TerminalHeader", styles)(TerminalHeader);



// WEBPACK FOOTER //
// ./src/components/list-items/Terminal/Header.js